import mansoqConfig from "@mansoqConfig";
import { BookOpen, Heart, Mail } from "lucide-react";
import { Link } from "raviger";
import { useTranslation } from "react-i18next";

const SUPPORT_EMAIL = "support@mansoq.com";
const MANSOQ_DOMAIN = "mansoq.com";
const MANSOQ_SLOGAN = "Care and Revenue. Perfectly Aligned.";
const MANSOQ_SLOGAN_AR = "الرعاية والإيراد، في نسقٍ واحد.";
const BUILT_WITH = "Built with";
const LOVE = "love";
const IN_RIYADH = "in Riyadh";

export const AuthHero = () => {
  const { urls, stateLogo, customLogo, customLogoAlt } = mansoqConfig;
  const customDescriptionHtml = __CUSTOM_DESCRIPTION_HTML__;
  const { t } = useTranslation();

  const logos = [stateLogo, customLogo].filter(
    (logo) => logo?.light || logo?.dark,
  );

  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-6 md:order-first md:h-full md:w-[calc(50%+130px)] md:flex-none md:p-0 md:px-16 md:pr-[calc(4rem+130px)]">
      <div></div>
      <div className="mt-4 flex flex-col items-start rounded-lg py-4 md:mt-12">
        <div className="mb-4 hidden items-center gap-6 md:flex">
          {logos.map((logo, index) =>
            logo && logo.light ? (
              <div key={index} className="flex items-center">
                <img
                  src={logo.light}
                  className="h-16 rounded-lg py-3"
                  alt="state logo"
                />
              </div>
            ) : null,
          )}
        </div>
        <div className="max-w-lg">
          <h1 className="sr-only">{t("mansoq")}</h1>
          <a
            href={urls.mansoq}
            className="inline-block"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit mansoq.com"
          >
            <img
              src={customLogoAlt?.light ?? "/images/mansoq_logo_light.svg"}
              className="h-auto w-full max-w-[29rem] drop-shadow-[0_18px_35px_rgba(0,0,0,0.18)]"
              alt="MANSOQ"
            />
          </a>
          {customDescriptionHtml ? (
            <div className="py-6">
              <div
                className="max-w-xl text-secondary-400"
                dangerouslySetInnerHTML={{
                  __html: __CUSTOM_DESCRIPTION_HTML__,
                }}
              />
            </div>
          ) : (
            <div className="max-w-xl py-6 pl-1 text-secondary-400">
              <p className="text-base font-bold tracking-tight md:text-lg lg:text-xl">
                {MANSOQ_SLOGAN}
              </p>
              <p
                lang="ar"
                dir="rtl"
                className="mt-2 w-fit text-base font-bold md:text-lg lg:text-xl"
              >
                {MANSOQ_SLOGAN_AR}
              </p>
              <p className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#F7F4EC]/90 md:text-base">
                <span>{BUILT_WITH}</span>
                <Heart
                  className="h-4 w-4 fill-[#C5A46D] text-[#C5A46D]"
                  role="img"
                  aria-label={LOVE}
                />
                <span>{IN_RIYADH}</span>
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="mb-6 flex items-center">
        <div className="max-w-lg text-xs md:text-sm">
          <div className="mb-3 flex flex-wrap items-center gap-3">
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="flex items-center gap-2 rounded-lg border border-white/15 bg-white/10 px-3 py-2 text-secondary-100 backdrop-blur-sm transition hover:border-white/30 hover:bg-white/15"
            >
              <Mail className="h-4 w-4 text-[#C5A46D]" aria-hidden="true" />
              <span>{SUPPORT_EMAIL}</span>
            </a>
            <a
              href={urls.mansoq}
              rel="noopener noreferrer"
              target="_blank"
              className="flex items-center gap-2 rounded-lg border border-white/15 bg-white/10 px-3 py-2 text-secondary-100 backdrop-blur-sm transition hover:border-white/30 hover:bg-white/15"
              aria-label="Visit mansoq.com"
            >
              <img src="/favicon.svg" className="h-6 w-6 rounded-md" alt="" />
              <span>{MANSOQ_DOMAIN}</span>
            </a>
          </div>
          <div className="mx-auto flex flex-wrap items-center gap-2">
            <a
              href={urls.documentation}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-[#F7F4EC] transition hover:text-[#C5A46D]"
            >
              <BookOpen className="h-4 w-4" aria-hidden="true" />
              {t("documentation_library")}
            </a>
            <span className="text-[#C5A46D]">|</span>
            <Link
              href="/licenses"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F7F4EC] transition hover:text-[#C5A46D]"
            >
              {t("third_party_software_licenses")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
